import React, { useState } from "react";
import SeatingStyle from "./SeatingStyle";
import httpServices from "../../../../services/httpServices";
import { useUser } from "../../../../context/UserContext";
import { toast } from "react-toastify";
import LoadingOverlay from "../../../../component/common/overlay";

const SeatingsArrangement = ({ venueId, setActiveStep, venueData }) => {
  const { user } = useUser();
  const [loading, setLoading] = useState(false);

  const [seatingData1, setSeatingData1] = useState([
    {
      seatingStyle: venueData?.venueSeatingArrangement?.[0]?.seatingStyle || "",
      minPersonCapacity:
        venueData?.venueSeatingArrangement?.[0]?.minPersonCapacity || "",
      maxPersonCapacity:
        venueData?.venueSeatingArrangement?.[0]?.maxPersonCapacity || "",
      subTypesAndAccommadations: [
        {
          subType:
            venueData?.venueSeatingArrangement?.[0]
              ?.subTypesAndAccommadations?.[0]?.subType || "",
          accomodation:
            venueData?.venueSeatingArrangement?.[0]
              ?.subTypesAndAccommadations?.[0]?.accomodation || "",
        },
      ],
    },
  ]);

  const [seatingData2, setSeatingData2] = useState([
    {
      seatingStyle: venueData?.venueSeatingArrangement?.[1]?.seatingStyle || "",
      minPersonCapacity:
        venueData?.venueSeatingArrangement?.[1]?.minPersonCapacity || "",
      maxPersonCapacity:
        venueData?.venueSeatingArrangement?.[1]?.maxPersonCapacity || "",

      subTypesAndAccommadations: [
        {
          subType:
            venueData?.venueSeatingArrangement?.[1]
              ?.subTypesAndAccommadations?.[0]?.subType || "",
          accomodation:
            venueData?.venueSeatingArrangement?.[1]
              ?.subTypesAndAccommadations?.[0]?.accomodation || "",
        },
      ],
    },
  ]);
  const handleAddSeating1 = () => {
    setSeatingData1([...seatingData1, { label: "", option_value: "" }]);
  };

  const handleAddSeating2 = () => {
    setSeatingData2([...seatingData2, { label: "", option_value: "" }]);
  };

  const handleRemoveSeating1 = (index) => {
    setSeatingData1(seatingData1.filter((_, i) => i !== index));
  };

  const handleRemoveSeating2 = (index) => {
    setSeatingData2(seatingData2.filter((_, i) => i !== index));
  };

  const [errors1, setErrors1] = useState([]);
  const [errors2, setErrors2] = useState([]);

  const handleValidation = () => {
    let validationErrors1 = [];
    let validationErrors2 = [];

    // Loop through seatingData1
    seatingData1.forEach((seating, index) => {
      let seatingErrors = {};
      if (!seating.seatingStyle) {
        seatingErrors.seatingStyle = "Seating style is required";
      }
      if (!seating.minPersonCapacity || seating.minPersonCapacity <= 0) {
        seatingErrors.minPersonCapacity =
          "Minimum capacity must be greater than 0";
      }
      if (!seating.maxPersonCapacity || seating.maxPersonCapacity <= 0) {
        seatingErrors.maxPersonCapacity =
          "Maximum capacity must be greater than 0";
      }
      seating.subTypesAndAccommadations.forEach((subType, subIndex) => {
        if (!subType.subType) {
          seatingErrors[`subType${subIndex}`] = "SubType is required";
        }
        if (!subType.accomodation) {
          seatingErrors[`accomodation${subIndex}`] =
            "Accommodation is required";
        }
      });
      validationErrors1[index] = seatingErrors;
    });

    // Loop through seatingData2 (assuming you have seatingData2)
    seatingData2.forEach((seating, index) => {
      let seatingErrors2 = {};
      if (!seating.seatingStyle) {
        seatingErrors2.seatingStyle = "Seating style is required";
      }
      if (!seating.minPersonCapacity || seating.minPersonCapacity <= 0) {
        seatingErrors2.minPersonCapacity =
          "Minimum capacity must be greater than 0";
      }
      if (!seating.maxPersonCapacity || seating.maxPersonCapacity <= 0) {
        seatingErrors2.maxPersonCapacity =
          "Maximum capacity must be greater than 0";
      }
      seating.subTypesAndAccommadations.forEach((subType, subIndex) => {
        if (!subType.subType) {
          seatingErrors2[`subType${subIndex}`] = "SubType is required";
        }
        if (!subType.accomodation) {
          seatingErrors2[`accomodation${subIndex}`] =
            "Accommodation is required";
        }
      });
      validationErrors2[index] = seatingErrors2;
    });

    setErrors1(validationErrors1);
    setErrors2(validationErrors2);

    const isValidSeating1 = validationErrors1.every(
      (seatingError) => Object.keys(seatingError).length === 0
    );
    const isValidSeating2 = validationErrors2.every(
      (seatingError) => Object.keys(seatingError).length === 0
    );

    return isValidSeating1 && isValidSeating2;
  };

  const onSubmit = async (e) => {
    e.preventDefault();
      if (venueData === null || venueData?.stepsDone < 4) {
        toast.warn("Please complete the previous step");
        setErrors1([]);
        setErrors2([]);
        return;
      }
    const isValid = handleValidation();
    if (!isValid) {
      return;
    }
    setLoading(true);

    try {
      const { response, error } = await httpServices.put(
        `/venue/update/${venueId}`,
        {
          venueSeatingArrangement: [...seatingData1, ...seatingData2],
          stepsDone: 5,
          userId: user?.userId,
        }
      );
      if (error) {
        throw error;
      }

      if (response.status === 200) {
        setActiveStep(5);
        toast.success("Seatings arrangement saved successfully");
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={onSubmit}>
      <div className="mt-3 p-3 bg-white relative">
        {loading && <LoadingOverlay />}
        <h3 className="text-blue fw-semibold text-xl mb-4">
          Seatings Arrangement
        </h3>
        <h4 className="text-lg">Seating Style 1</h4>
        <SeatingStyle
          errors={errors1}
          seatingData={seatingData1}
          setSeatingData={setSeatingData1}
          handleRemoveSeating={handleRemoveSeating1}
          handleAddSeating={handleAddSeating1}
        />
        <h4 className="text-lg mt-6">Seating Style 2</h4>
        <SeatingStyle
          errors={errors2}
          seatingData={seatingData2}
          setSeatingData={setSeatingData2}
          handleRemoveSeating={handleRemoveSeating2}
          handleAddSeating={handleAddSeating2}
        />
        <div className="h-20 flex justify-center items-end mt-6">
          <button type="submit" className="gradian-btn text-white px-3 py-2">
            Save & Proceed
          </button>
        </div>
      </div>
    </form>
  );
};

export default SeatingsArrangement;
